import { LookupValue } from "./lookup.model";

export interface SealingElementEquipmentType extends LookupValue {
  bulletinUrl?: string;
  imageUrl?: string;
}

export interface BulkResponse<T> {
  count?: number;
  value: T[]
}

export interface SealingElement {
  partNumber?: string;
  itemName?: string;
  sellableEHID?: string;
  sellableWHID?: string;
  sbuid?: string;
  subSBUID?: string;
  productFamilyID?: string;
  leadTime?: number;
  surge?: number;
  purchasePrice?: number;
  nominalPipeSizeID?: number;
  equipmentTypeID?: number;
  innerDiameterLowerRange?: number;
  innerDiameterUpperRange?: number;
  materialID?: number;
  notes?: string;
  restricted?: boolean;
  restrictedNotice?: string;
  inactiveDate?: Date;
  createdDate?: Date;
  createdBy?: string;
  updatedDate?: Date;
  updatedBy?: string;
}


export interface SealingElementDetail extends SealingElement {
  sellableEHText?: string;
  sellableWHText?: string;
  sbuText?: string;
  subSBUText?: string;
  productFamilyText?: string;
  pipeSizeText?: string;
  materialText?: string;
  equipmentTypeText?: string;
  pluggingHeads: { description: string, pluggingHeadPartNumber: string }[]
}


export interface ProductFamily {
  id: string;
  subSBUID: string;
  name: string;
  inactiveDate?: Date;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
}

export interface SBU {
  id: string;
  name: string;
  inactiveDate?: Date;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
}

export interface SubSBU {
  id: number;
  subSbuID: string;
  name: string;
  sbuID: string;
  inactiveDate?: Date;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
}

export interface SellableStatus {
  sellableID: string;
  description: string;
  inactiveDate?: Date;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
}


export interface PipeSchedule {
  pipe_size: number | string;
  outside_diameter: number;
  schedules: { [key: string]: Schedule | null };
}

export interface Schedule {
  wall_thickness?: number | null;
}

export enum SealingElementEquipmentTypes {
  'SHORTSTOPP' = 1,
  'SHORTSTOPP275500' = 2,
  'STOPPLE' = 3,
  'STOPPLETrain' = 4,
  'Folding' = 5
}


export interface SealingElementPluggingHead {
  sealingElementPartNumber: string;
  pluggingHeadPartNumber: string;
  pipeSizeID: number;
  description: string;
  equipmentTypeID: number;
  inactiveDate?: Date;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
}
